import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpService } from '@services/http.service';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { Device } from '@models/device';
import { UserDevice } from '@models/user-device';
import { User } from '@models/user';

@Injectable()

export class DevicesService extends HttpService {
  readonly DEVICES_API = `${environment.apiUrl}/devices`;
  readonly USER_DEVICES_API = `${environment.apiUrl}/user-devices`;

  getListDevices(filterData?: any): Observable<any> {
    const defaultOptions = this.createHeaders();
    if (filterData) {
      defaultOptions['params'] = new HttpParams({ fromObject: filterData });
    }
    return this.get(this.DEVICES_API, defaultOptions);
  }

  getDevice(deviceId: string): Observable<Device> {
    const defaultOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.storageService.get('tok')}`,
      }),
    };
    return this.get(`${this.DEVICES_API}/${deviceId}`, defaultOptions);
  }

  getUsersDevice(deviceId: string): Observable<User[]> {
    const options = this.createHeaders();
    return this.get(`${this.DEVICES_API}/${deviceId}/users`, options);
  }

  getDeviceUsers(deviceId: string): Observable<UserDevice[]> {
    const defaultOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.storageService.get('tok')}`,
      }),
    };
    return this.get(`${this.DEVICES_API}/${deviceId}/users`, defaultOptions);
  }

  unsuscribeUserDevice(userId: string, deviceId: string): Observable<any> {
    const options = this.createHeaders();
    return this.put(
      `${this.USER_DEVICES_API}/unsuscribe/admin/${userId}/${deviceId}`,
      {},
      options
    );
  }

  updateDeviceDataFromDate(deviceId: string, date: Date): Observable<any> {
    const defaultOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.storageService.get('tok')}`,
      })
    };
    const body = { dateFrom: date.toISOString() };
    return this.put(`${this.DEVICES_API}/${deviceId}/dataFromDate`, body, defaultOptions);
  }

  deleteDevice(deviceId: string): Observable<any> {
    const options = this.createHeaders();
    return this.delete(`${this.DEVICES_API}/${deviceId}`, options);
  }

  updateDevice(deviceId: string, data: any): Observable<any> {
    const options = this.createHeaders();
    return this.put(`${this.DEVICES_API}/${deviceId}`, data, options);
  }

  updateDeviceName(deviceId: string, name: string): Observable<any> {
    const defaultOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.storageService.get('tok')}`,
      })
    };
    const body = { name: name };
    return this.put(`${this.DEVICES_API}/${deviceId}/name`, body, defaultOptions);
  }

  assignUserDevice(deviceData, userId): Observable<any> {
    const options = this.createHeaders();
    return this.post(`${this.USER_DEVICES_API}/${userId}`, deviceData, options);
  }

  getDiagnostic(deviceId: string, startDate: string = null, endDate: string = null): Observable<UserDevice[]> {
    const defaultOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.storageService.get('tok')}`,
      }),
    };
    let url: string;
    if (startDate && endDate) {
      url = `${this.DEVICES_API}/${deviceId}/diagnostic?startDate=${startDate}&endDate=${endDate}`;
    } else {
      url = `${this.DEVICES_API}/${deviceId}/diagnostic`;
    }
    return this.get(url, defaultOptions);

  }

}
